<template>
  <DModal
    :show-close="false"
    :isBgOverlay="true"
    @close="$emit('close')"
    :appendToBody="true"
    style="z-index: 12312312312312"
  >
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent" @click.stop>
      <div class="d-modal__header">
        <h2 v-if="isEditing">Redigér</h2>
        <h2 v-else>Opret</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content">
        <div class="d-input-group">
          <label class="d-label">Navn</label>
          <input
            type="text"
            class="d-input"
            v-model="name"
            ref="input_title"
            :placeholder="placeholder1"
          >
        </div>
        <div class="d-input-group">
          <label class="d-label">Kode</label>
          <input
            type="text"
            class="d-input"
            v-model="code"
            :placeholder="placeholder2"
          >
        </div>
      </div>

      <div class="d-modal__buttons">
        <div>
          <button
            v-if="isEditing"
            class="do-bttn"
            :class="{'do-bttn--submit--loading': isDeleting}"
            @click="onClickDelete"
          >
            <span class="icon-bin"></span>
          </button>
        </div>
        <div>
          <button class="do-bttn" @click="$emit('close')">
            {{ $t('vue2.common.cancel') }}
          </button>
          <button
            class="do-bttn do-bttn--submit"
            :class="{
              'do-bttn--submit--disabled': !isValid || isSubmitting,
              'do-bttn--submit--loading': isSubmitting
            }"
            @click="onSubmit"
          >
            {{ isEditing ? 'Opdatér' : 'Opret' }}
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
// import docendo from '../../../docendo'
// import eventbus from '../../../eventbus'

export default {
  name: 'SalaryRuleCostCentersCreateModal',
  components: {DModal},
  props: {
    placeholder1: {
      type: String,
      default: ''
    },
    placeholder2: {
      type: String,
      default: ''
    },
    theEditItem: {
      type: Object,
      default: null // ex { name: 'Vest', code: '54321' }
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    isDeleting: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: '',
      code: ''
    }
  },
  computed: {
    isEditing () {
      return !!this.theEditItem
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    isValid () {
      return this.name.trim().length > 0 && String(this.code).trim().length > 0
    }
  },
  methods: {
    onSubmit () {
      if (!this.isValid) {
        return
      }
      const obj = {
        name: this.name,
        code: this.code
      }
      this.$emit('onSubmit', obj)
    },
    onClickDelete () {
      console.log('onClickDelete')
    }
  },
  beforeMount () {
    if (this.theEditItem) {
      const t = this.theEditItem
      this.name = t.name ? String(t.name) : ''
      this.code = t.code !== undefined && t.code !== null ? String(t.code) : ''
    }
  },
  mounted () {
    this.$nextTick(_ => {
      const el = this.$refs.input_title
      if (el) el.focus()
    })
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 500px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__buttons {
  display: flex;
  justify-content: space-between;
  padding: 1rem 2rem;
}

.d-modal__buttons > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-modal__content {
  padding: 1rem;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group {
  margin-bottom: 1rem;
}

.d-input-group-flex {
  display: flex;
  padding: 0 1rem;
  gap: 1rem;
}

.d-input-group-flex > div {
  flex: 1;
}

.d-input-group-flex label.d-label {
  margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// TableCreateModal.vue?85b1c970